<template>
    <div id="home">

        <el-menu
            class="el-menu-vertical-demo"
            text-color="#333333"
        >
          <el-menu-item class="el-logo" @click="home('/admin/index/index')">后台管理系统</el-menu-item>
        </el-menu>

        <el-row class="tac el-menu-demo">
            <el-menu :default-active="activeIndex2"
                     text-color="#333"
                     active-text-color="#f00"
                     class="el-menu-demo" mode="horizontal" @select="handleSelect">
<!--                <el-submenu v-for="(item,index) in leftmenu" :key="index" :index="item.id+''">-->
<!--                    <template slot="title"><i :class="item.icon"></i>{{item.name}}</template>-->
<!--                    <el-menu-item v-for="(info,idx) in item['child']" :key="idx" :index="info.path+''" @click="addTab(info.href,info.path)">{{info.name}}</el-menu-item>-->
<!--                </el-submenu>-->
            </el-menu>

            <div id="admin_User">
                <el-avatar :size="30" id="circleUrl" :src="circleUrl"></el-avatar>
                你好，管理员&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
                <i class="el-icon-switch-button" @click="handCLickLogin('/')"></i>
            </div>
        </el-row>

        <el-row class="tac el-menu-aside">
            <el-menu
                :default-active="activeIndex"
                class="el-menu-vertical-demo"
                @open="handleOpen"
                :unique-opened="true"
                @close="handleClose">

                <el-submenu v-for="(item,index) in leftmenu" :key="index" :index="item.id+''">
                    <template slot="title">
                        <i :class="item.icon"></i>
                        <span>{{item.name}}</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item v-for="(info,idx) in item['child']" :key="idx" :index="info.path+''" @click="addTabs(info.href,info.path)">{{info.name}}</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu>

        </el-row>

    </div>
</template>

<script>
    export default {
        name: '',
        data() {
            return {
                circleUrl:'http://shxswjt.com//public/uploads/20200321/f5c3d00dcc7328b60ab943b6786394b0.png',
                activeIndex: '',
                isCollapse: false,
                OpenAside:true,
                activeIndex2:'',
                currentMenu:'',
                activePath:'category',
                leftmenu:'',
                menuname:'',
                pathurl:'',

                editableTabsValue: '2',
                editableTabs: [],
                tabIndex: 2
            };
        },
        watch: {},
        methods: {
            handCLickLogin(e){
                var that = this
                that.$message.success('退出成功')
                that.$router.push(e)
                let path = that.$route.path;
                that.pathurl = path
            },
            home(a){
                console.log(a)
                this.$router.push(a)
                let path = this.$route.path;
                var that = this
                that.pathurl = path

                that.activeIndex2 = ''
                that.activeIndex = ''
            },

            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            },
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
            },


            addTab(a,i) {
                this.$router.push(a)
                let path = this.$route.path;
                var that = this
                that.pathurl = path

                that.activeIndex    =   i
                that.activeIndex2    =   i
            },
            addTabs(a,i) {
                this.$router.push(a)
                let path = this.$route.path;
                var that = this
                that.pathurl = path

                that.activeIndex    =   i
                that.activeIndex2    =   i
            },

        },

        mounted(){
            let path = this.$route.path;
            console.log(path)
            var that = this
            that.pathurl = path
            this.axios.get(this.$url.baseUrl+'/menu/getmenu', {
                params: {
                    getpath: path
                },
                headers: {
                    'Content-Type':'application/x-www-form-urlencoded',
                }
            })
            .then(function (response) {
                console.log(response.data)
                that.leftmenu = response.data.menuinfo
                that.activeIndex    =   response.data.path
                that.activeIndex2    =   response.data.path

            })
            .catch(function (error) {
                console.log(error);
            });

        }
    }
</script>

<style>
    *{
        padding: 0;
        margin: 0;
    }
    a{
        text-decoration: none;
    }

    #admin_User{
        position: absolute;
        top: 0;
        right: 56px;
        line-height: 60px;
        display: inline-block;
        z-index: 9;
        font-size: 14px;
    }

    .el-submenu .el-menu-item{
        min-width: initial !important;
        width: 100%;
    }

    #admin_User #circleUrl{
        position: relative;
        top: 8px;
    }

    .insert_tap .el-tabs__item{
        box-sizing: border-box;
        height: 34px;
        line-height: 34px;
        border-radius: 2px;
        margin-right: 6px !important;
        border: 1px solid #dcdfe6 !important;
    }

    .el-tabs__header{
        margin-bottom: 10px;
    }

    .insert_tap{
        margin-top: 60px;
        padding: 10px 10px 0;
        /*background: #FFFFFF;*/
    }

    .el-menu-aside .act{
        /*background: rgb(67,74,80);*/
    }

    .el-menu-demo{
        position: fixed !important;
        top: 0;
        left: 11%;
        width: 90%;
        height: 60px;
        box-shadow: 8px 2px 8px rgba(0,0,0,.15);
        border: 0 !important;
        z-index: 9;
    }

    .el-tabs--card>.el-tabs__header,.el-tabs--card>.el-tabs__header .el-tabs__nav{
        border: 0 !important;
    }
    .el-menu--horizontal>.el-submenu{

    }

    .el-menu--horizontal>.el-submenu.is-active .el-submenu__title,.el-menu--horizontal .el-menu .el-menu-item.is-active,.el-menu-item.is-active{
        /*border-bottom: 2px solid #409EFF !important;*/
        /*color: #FFFFFF !important;*/
        /*background: #409EFF !important;*/
    }

    .el-menu--horizontal .el-menu .el-menu-item{
        height: 50px;
        line-height: 50px;
    }

    .el-menu--horizontal>.el-submenu.is-active .el-submenu__title  i{
        color: #FFFFFF !important;
    }

    .el-menu-aside{
        width: 11%;
        position: fixed !important;
        left: 0;
        top: 60px;
        bottom: 0;
        height: 100%;
        /*background-color:#545c64;*/
        z-index: 9;
    }

    .right-menu{
        width: 300px;
        display: flex;
        position: absolute;
        right: 120px;
        top: 2px;
        border: initial;
        z-index: 9;
    }

    .el-menu-aside {
        text-align: left;
    }

    .el-logo{
        position: fixed !important;
        top: 0;
        left: 0;
        height: 60px !important;
        line-height: 60px !important;
        font-size: 16px !important;
        text-align: center;
        width: 11%;
        background-color:#FFFFFF;
        /*color: #FFFFFF;*/
        z-index: 9;
    }

    .el-menu-vertical-demo{
        border-right: inherit;
        width: 100%;
    }
    #main_body{
        position: absolute;
        left: 11%;
        top: 5%;
        right: 60px;
        width: 87.97%;
        height: 100%;
        background: #f2f2f2;
        padding: 10px;
        overflow: hidden;
    }

    .el-main{
        padding: 24px;
    }
    .mainBody{
        background: #FFFFFF;
        padding: 24px;
        zoom: 1;
    }

    .el-select{
        display: block;
    }

    .main_body{
        position: absolute;
        left: 10px;
        top: 2.5%;
        width: 99%;
        background: #FFFFFF;
        overflow: hidden;
    }

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue